/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable react/jsx-handler-names */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-nested-ternary */
/* eslint-disable complexity */
/* eslint-disable max-len */
import './styles.css';

import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import Grid from '@vtblife/uikit-grid';
import Icon from '@vtblife/uikit-icons';
import { Button, Typography } from '@vtblife/uikit';
// import { Checkbox } from '@vtblife/uikit/legacy';

import { FixedHeightBanner } from '@vtblife/media-kit/dist/banners/fixed-height-banner/fixed-height-banner';
import { FixedSizeBanner } from '@vtblife/media-kit/dist/banners/fixed-size-banner/fixed-size-banner';
import { checkRegionIsPromoSamolet } from '@search/vtbeco-frontend-core/dict/samolet-regions';
import { getBannerConfig, BannerType } from '@search/vtbeco-frontend-core/dict/samolet-banner-config';

import { ShareButton } from '@search/vtbeco-frontend-core/domain/share/ShareButton';

import { Modal, ModalSize } from '@search/vtbeco-ui/src/components/Modal';
// import Breadcrumb from '@search/vtbeco-ui/src/components/Breadcrumb';
// import { YMapLayer } from '@search/ymap/src/Layer';
import { YMapPlacemarkPoint } from '@search/ymap/src/Placemark';
import { YMapControlPanorama, YMapControlFullscreen, YMapControlCentering, YMapControlGroup } from '@search/ymap/src/Control';
import classname from '@search/classname/src';

import { errorCatcherWrap } from '@search/error/src/catcher';
import {
    GeoKind,
    NewBuilding,
    // SellerType
} from '@search/filter-enums/enums';
import { Rooms } from '@search/filter-enums/enums';
import { Currency } from '@search/filter-enums/enums/Currency';
import { regionsEnumeration } from '@search/filter-enums/enums/Region';

import {
    ApplicationIdEnum,
    SellerTypeEnum
} from '@search/graphql-typings';
import { pickRandom } from '@search/helpers/src/newbuilding-promo';
import { SearchRoute, useRouter, ISearchType } from '@search/offer-search-routes/src';
import { SearchSeoChpuMapper, TSearchSeoChpuMapper } from '@search/offer-search-routes/src/searchRoute/SearchSeoChpuMapper';
import { RegionIdEnum } from '@search/vtbeco-frontend-core/enums';
import { AgentFavoritesDropdown } from '@search/classified-common/src/Agent/AgentFavoritesDropdown/AgentFavoritesDropdown';

import { useStaticPathConfig } from '@search/common-core/src/StaticPathContext';
// import { useOfferDetailsBreadcrumbSections } from '@search/vtbeco-frontend-core/domain/offer/details/breadcrumbsSections';
import { useOfferPhoneQuery } from '@search/vtbeco-frontend-core/domain/offer/search/page/OfferPhoneQuery';
import {
    useOfferNearestMapLoader, useOfferNearestMapState
} from '@search/vtbeco-frontend-core/domain/offer/ymap/page/SearchOffersMapQuery/useOfferNearestMapLoader';
import { useOfferTypeAnalytics } from '@search/vtbeco-frontend-core/view/common/hooks/useOfferTypeAnalytics';
import {
    useFavoritesButtonState,
    useHiddenButtonState
} from '@search/vtbeco-frontend-core/view/common/components/FavoritesButton/useFavoritesButtonState';
import { FavoritesButton } from '@search/vtbeco-frontend-core/view/common/components/FavoritesButton/FavoritesButton';

import { getOfferCardGtmId, OfferType } from '@search/vtbeco-frontend-core/domain/offer/search/page/OfferQuery';
import {
    dealTypeCompat, dealTypePeriodCompat, useOfferRouteListCompat, priceCompat,
    realtyObjectFilterCompat, sellerCompat, useHandyAddressCompat
} from '@search/vtbeco-frontend-core/domain/offer/search/page/SearchOffersQuery';
import { roomTypeFilterCompat } from '@search/vtbeco-frontend-core/domain/offer/search/page/SearchOffersQuery/helpers/roomTypeFilterCompat';
import { areaCompat } from '@search/vtbeco-frontend-core/domain/offer/search/page/SearchOffersQuery/helpers/areaCompat';
import { CardAuthorBadge } from '@search/vtbeco-frontend-core/view/common/components/CardAuthorBadge';
// import { formatCallbackMailExtra } from '@search/vtbeco-frontend-core/view/common/tools/formatCallbackMailExtra';
import { formatNumber } from '@search/helpers/src/formatNumber';

import ImageBanner from '@search/vtbeco-frontend-core/domain/newbuilding/components/common/ImageBanner';
import { AnalyticsFromTags, ClassifiedAnalytics } from '@search/vtbeco-frontend-core/domain/offer/analytics/ClassifiedAnalytics';
import { ModeratorExtension } from '@search/vtbeco-frontend-core/domain/offer/ModeratorExtension';
import { SeoGeos } from '@search/vtbeco-frontend-core/domain/offer/search/breadcrumbSections';
// import { OfferYMapUnionPlacemark } from '@search/vtbeco-frontend-core/domain/offer/ymap/union/UnionPlacemark';
import PriceDetail from '@search/vtbeco-frontend-core/view/common/components/PriceDetail';
import Price from '@search/vtbeco-frontend-core/view/common/components/Price';
import { Mortgage2StarterLink } from '@search/vtbeco-frontend-core/view/common/components/MinimalBanksMortgage/mortgage2/starter/Mortgage2StarterLink';
import { OfferRouteCardList } from '@search/vtbeco-frontend-core/view/common/components/OfferRouteCardList';
import ReportButton from '@search/vtbeco-frontend-core/view/common/components/ReportButton';
import RgrLogo from '@search/vtbeco-frontend-core/view/common/components/RgrLogo';
// import { TooltipUnderline } from '@search/vtbeco-frontend-core/view/common/components/TooltipUnderline';
import { IImage } from '@search/vtbeco-frontend-core/view/desktop/components/snippet/parts/GallerySnippet';
import { YMapPanoramaDesktop } from '@search/vtbeco-frontend-core/view/common/components/YMapPanorama/Desktop';
// import { CallToActionButton } from '@search/vtbeco-frontend-core/view/common/components/CallToActionButton';
import { RepairLinks } from '@search/vtbeco-frontend-core/view/common/components/Repair/links/RepairLinks';
import { RepairModal } from '@search/vtbeco-frontend-core/view/common/components/Repair/modal/RepairModal';
import { DesktopRepairGalleryBanner } from '@search/vtbeco-frontend-core/view/common/components/Repair/banner/desktop/DesktopRepairGalleryBanner';

import useDeveloperPromo from '@search/vtbeco-frontend-core/domain/newbuilding/developer-promo/useDeveloperPromo';
import { DeveloperBanner } from '@search/vtbeco-frontend-core/domain/newbuilding/developer-promo/types';

import { buildInfoBuilding } from '@search/gql-selectors/src/build_InfoBuilding';
import { mainBuildInfoFlat, additionalBuildInfoFlat } from '@search/gql-selectors/src/build_InfoFlat';
import { buildMainInfoHouse, buildAdditionalInfoHouse } from '@search/gql-selectors/src/build_InfoHouse';
import { buildMainInfoLand, buildAdditionalInfoLand } from '@search/gql-selectors/src/build_InfoLand';
import { buildMainInfoRoom, buildAdditionalInfoRoom } from '@search/gql-selectors/src/build_InfoRoom';
import { buildInfoInfrastructure } from '@search/gql-selectors/src/build_infoInfrastructure';
import { getApartments } from '@search/gql-selectors/src/infoHelpers';
import {
    InformationsEnum,
    // InformationsIconEnum,
    TGenerateSeoUrlParams
} from '@search/gql-selectors/src/infoHelpers/types/InfoModel';
import { useClickerTracker } from '@search/vtbeco-frontend-core/src/services/clickerTracker/useClickerTracker';

import { SharePrintButton } from '@search/vtbeco-frontend-core/domain/share/SharePrintButton';
import { OfferStatView } from '@search/vtbeco-frontend-core/domain/offer/OfferStatView/OfferStatView';
import { NewBuildingSectionHeading } from '@search/vtbeco-frontend-core/view/desktop/components/NewBuildingSectionHeading';
import { NewBuildingNews } from '@search/vtbeco-frontend-core/view/desktop/components/NewBuildingNews';
// import { OfferTinySnippetList } from '@search/classified-common/src/OfferTinySnippetList';

import { OfferPhoneModal2 } from '@search/vtbeco-frontend-core/view/common/components/OfferPhone/OfferPhoneModal2';
import { NotFoundPage } from '@search/vtbeco-frontend-core/view/common/components/NotFound/NotFoundPage';
// import { OfferPhoneModal2Link } from '@search/vtbeco-frontend-core/view/common/components/OfferPhone/OfferPhoneModal2Link';
import { useOfferPhoneModalOpener } from '@search/vtbeco-frontend-core/view/common/components/OfferPhone/useOfferPhoneModal';
import { useClassifiedOfferDataLayerPush } from '@search/vtbeco-frontend-core/domain/offer/analytics/ClassifiedOfferGtmContext';
import { useGtmOnVisible } from '@search/vtbeco-frontend-core/domain/google/useGtmOnVisible';
// import { TrackBuildingButton } from '@search/classified-common/src/TrackBuildingButton';
import { DescriptionCell } from '@search/classified-common/src/DescriptionCell';
import { ClClickableAddress } from '@search/classified-common/src/ClClickableAddress/ClClickableAddress';
import { ClOrderOfferCardVas } from '@search/classified-common/src/ClOrderOfferCardVas/ClOrderOfferCardVas';
import { Mortgage3Calc } from '@search/vtbeco-frontend-core/view/common/components/MinimalBanksMortgage/mortgage3';
import { useGeoRootRegion } from '@search/geo/src/GeoRootRegionProvider';

import { HideButton } from '@search/vtbeco-frontend-core/view/common/components/FavoritesButton/HideButton';
import { NotesButton } from '@search/vtbeco-frontend-core/view/common/components/FavoritesButton/NotesButton';
import { NotesEditor } from '@search/vtbeco-frontend-core/view/common/components/FavoritesButton/NotesEditor';
import { CALLTOUCH_ID } from '@search/classified-common/src/scripts/useCalltouch';
import {
    // SimilarOffers,
    SimilarNewBuildingOffersSection
} from '@search/classified-common/src/SimilarNewBuildingOffers/SimilarNewBuildingOffersSection';
// import { MortgageInRentOffers } from '@search/classified-common/src/MortgageInRentOffers/MortgageInRentOffers';
import { getSeoSearchRouteParamsByInformationItem } from '@search/vtbeco-frontend-core/domain/seo/getSeoSearchRouteParamsByInformationItem';
import { YandexBanner } from '@search/classified-common/src/YandexBanner/YandexBanner';
import { useOfferCardLink } from '@search/vtbeco-frontend-core/domain/offer/search/page/SearchOffersQuery';
import { MortgageStupidBanner } from '@search/vtbeco-frontend-core/view/common/components/MinimalBanksMortgage/stupid/MortgageStupidBanner';
import { useM2AuthContext } from '@search/auth/src/M2AuthProvider';
import { getDeveloperBannerGtmData } from '@search/vtbeco-frontend-core/domain/newbuilding/developer-promo/analytics';

import { ExpandableDescription } from '@search/classified-common/src/ExpandableDescription/ExpanadableDescription';
import { ExpandableInfo } from '@search/classified-common/src/ExpandableInfo/ExpandableInfo';
import { LandMortgage } from '@search/vtbeco-frontend-core/view/common/components/MinimalBanksMortgage/LandMortgage';
import { useMinimalMortgageRateLoader } from '@search/vtbeco-frontend-core/view/common/components/MinimalBanksMortgage/MinimalMortgageRate/useMinimalMortgageRate';
import { offerRegionToMortgage } from '@search/vtbeco-frontend-core/domain/offer/regionToBackoffice';
import { ClMortgageCalculator } from '@search/mortgage-calculator/src/ClMortgageCalculator';
import { OfferCardMortgageButton } from '@search/mortgage-calculator/src/components/common/OfferCardMortgageButton';
import { useCookies } from 'react-cookie';
import { NewBuildingSpecialEvents, NewBuildingSpecialEventsHeading } from '@search/vtbeco-frontend-core/view/common/components/NewBuildingSpecialEvents';
import { YMapDesktop } from './parts/YMapDesktop';
import { PitBannerDesktop } from './PitBannerDesktop';
// import { SubscribePriceTooltip } from './parts/SubscribePriceTooltip';
import GalleryOfferCard from './parts/GalleryOfferCard';
import NewBuildingMiniCard from './parts/NewBuildingMiniCard';
import { StaticSectionItem, StaticSectionItemValue, StaticSectionItemLabel } from './parts/StaticSectionItem';

export const cn = classname.bind(null, 'OfferCard');

export const OfferCard2 = errorCatcherWrap(function OfferCard2({
    offer,
    userId,
    userPhone,
    shouldShowVasBlock,
    mortgageBannerMinutesVariant,
    mortgageBannerTextVariant,
    isMyOffer
}: {
    mortgageBannerTextVariant: number;
    mortgageBannerMinutesVariant: number;
    offer: OfferType;
    userId: string;
    userPhone: string;
    shouldShowVasBlock: boolean;
    isMyOffer?: boolean;
}) {
    const { auth } = useM2AuthContext();
    const staticPath = useStaticPathConfig();
    const realtyObject = offer?.realtyObject;
    const dealType = offer?.dealType;
    const coordinates = offer.location.coordinates;
    const dealTypeEnum = dealTypeCompat(dealType);
    const offerType = realtyObjectFilterCompat(realtyObject);
    const price = priceCompat(dealType);
    const { trackOfferView, trackPhoneView } = useClickerTracker();
    const containerRef = useRef<HTMLDivElement>(null);
    const mortgageCalculatorRef = useRef<HTMLDivElement>(null);
    const similarOffersRef = useRef<HTMLDivElement>(null);
    const [ repairModal, setRepairModal ] = useState(false);
    const dataLayerPush = useClassifiedOfferDataLayerPush();
    const [
        minimalMortgagePayment,
        setMinimalMortgagePayment
    ] = useState<string|undefined>(undefined);
    const newBuilding = offer?.newBuildingCard;

    const closeRepairModal = useCallback(() => {
        setRepairModal(false);
    }, [ setRepairModal ]);
    const openRepairModal = useCallback(() => {
        dataLayerPush({
            event: 'up_action',
            theme: 'remont',
            page_type: 'card',
            type: 'card_count_click'
        });

        setRepairModal(true);
    }, [ dataLayerPush, setRepairModal ]);

    const roomsType = realtyObject?.__typename === 'ProfOfferFlat' ?
        roomTypeFilterCompat(realtyObject.roomType) :
        undefined;

    const scrollToMortgageCalculator = useCallback(() => {
        mortgageCalculatorRef?.current?.scrollIntoView({ behavior: 'smooth' });
    }, []);

    const scrollToSimilarOffers = useCallback(() => {
        similarOffersRef?.current?.scrollIntoView({ behavior: 'smooth' });
    }, []);

    const totalArea = realtyObject?.__typename === 'ProfOfferFlat' || realtyObject?.__typename === 'ProfOfferHouse' ?
        areaCompat(realtyObject.totalArea) :
        (
            realtyObject?.__typename === 'ProfOfferRoom' ?
                areaCompat(realtyObject.livingArea) :
                realtyObject?.__typename === 'ProfOfferLand' ?
                    areaCompat(realtyObject.area) :
                    null as never
        );
    const isPledge = (dealType?.__typename === 'ProfOfferDealSell' && dealType.hasBankPledge) ?? false;
    const isRgrMember = offer.badges?.isRgrMember;
    const hasAnyPriority = offer.status?.hasAnyPriority ?? false;

    const isPit = offer.seller.sellerType === SellerTypeEnum.Pit;
    const onlineView = offer.onlineView ?? false;

    const isSellFlat = realtyObject?.__typename === 'ProfOfferFlat' && dealType?.__typename === 'ProfOfferDealSell';
    const isNewBuilding =
        (realtyObject?.__typename === 'ProfOfferFlat' && realtyObject.building?.isNewbuilding) ?? false;
    const isNewBuildingDeveloperFlat = isNewBuilding && offer.seller.sellerType === 'DEVELOPER';
    const offerRoutes = useOfferRouteListCompat(offer);
    const seller = sellerCompat(offer.seller);
    const isDeleted = offer?.status?.isDeleted ?? false;

    const addresses = useHandyAddressCompat({
        dealType: offer.dealType,
        realtyObject: offer.realtyObject,
        location: offer.location,
        clickableAddress: offer.location.clickableAddress,
        id: offer.id
    });

    const metersToCentralSquare = offer.location.cityCenterInfo?.metersToCentralSquare;
    const locatedInCenter = offer.location.cityCenterInfo?.locatedInCenter ?? false;
    const metersToCenter = metersToCentralSquare && metersToCentralSquare <= 30000 ?
        String(Math.round(metersToCentralSquare / 100) / 10).replace('.', ',') :
        undefined;
    const metersToCenterText = locatedInCenter ?
        'В центре' :
        metersToCenter ? `до центра ${metersToCenter} км` : '';

    const favorites = useFavoritesButtonState({
        id: offer.id,
        noteTextInitial: offer.noteText,
        isFavorite: offer.isFavorite ?? false,
        eventAddId: dealType?.__typename === 'ProfOfferDealSell' && realtyObject?.__typename === 'ProfOfferFlat' ?
            ClassifiedAnalytics.SearchCardSaleFlatAddFavorites :
            undefined,
        organizationName: seller.organizationName
    });

    const hidden = useHiddenButtonState({
        id: offer.id,
        isHidden: offer.isHidden ?? false
    });

    const phone = useOfferPhoneQuery({
        isCard: true,
        callTouchId: offer.realtyObject?.__typename === 'ProfOfferFlat' && offer.realtyObject.building?.isNewbuilding ?
            CALLTOUCH_ID :
            undefined,
    });
    const {
        closePhoneModal,
        openPhoneModal,
        isPhoneModalOpened
    } = useOfferPhoneModalOpener({ offerId: offer.id });
    const [ placeCallPhoneModal, setPlaceCallPhoneModal ] = useState<'check_request_link' | 'check_request_clop'>();

    const handlePhoneLoad = useCallback((
        offerPhoneClickGtmId?: string,
        placeCall: 'check_request_link' | 'check_request_clop' = 'check_request_clop'
    ) => {
        if (! offer) return;

        if (offerPhoneClickGtmId) {
            let analytics = {
                event: offerPhoneClickGtmId,
                organizationName: seller.organizationName
            };

            if (isNewBuildingDeveloperFlat) {
                analytics = {
                    ...analytics,
                    // @ts-ignore
                    'nb-id': realtyObject?.building?.newBuildingId,
                    'nb-name': realtyObject?.building?.newBuildingBasicInfo?.title,
                    'developer-name': seller?.organizationName ?? ''
                };
            }

            dataLayerPush(analytics);
        }

        if (! phone.phoneHref) {
            phone.load({ offerId: offer.id });
        }

        ! isNewBuilding && isSellFlat && dataLayerPush({ event: 'up_action', theme: 'legal', type: 'check_click' });
        setPlaceCallPhoneModal(placeCall);
        openPhoneModal(offerPhoneClickGtmId ? undefined : 0);

        if (phone.phoneHref) {
            trackPhoneView(offer.id, phone.countryCode, phone.number);
        }
    }, [
        trackPhoneView, openPhoneModal, phone, isNewBuilding, isSellFlat,
        offer, isNewBuildingDeveloperFlat, realtyObject, seller, dataLayerPush
    ]);

    const gtmPhoneLabels = getOfferCardGtmId(offer);

    const handlePhoneLoadTop = useCallback(() => {
        handlePhoneLoad(gtmPhoneLabels?.top);
        dataLayerPush({ event: 'up_evt_phone', partner: offer.fromCian ? 'cian' : 'unknown' });

        if (isPit) dataLayerPush({ event: 'classified_im_trade_card_show_tel' });
    }, [ handlePhoneLoad, gtmPhoneLabels, dataLayerPush, offer.fromCian, isPit ]);

    const handlePhoneLoadBottom = useCallback(() => {
        if (isPit) dataLayerPush({ event: 'classified_im_trade_card_show_tel' });
        handlePhoneLoad(gtmPhoneLabels?.bottom);
        dataLayerPush({ event: 'up_evt_phone', partner: offer.fromCian ? 'cian' : 'unknown' });
    }, [ isPit, dataLayerPush, handlePhoneLoad, gtmPhoneLabels, offer.fromCian ]);

    // const handlePhoneLoadLink = useCallback(() => {
    //     handlePhoneLoad(undefined, 'check_request_link');
    // }, [ handlePhoneLoad ]);

    const [ isPanoramaOpen, setIsPanoramaOpen ] = useState(false);
    const togglePanorama = useCallback(() => {
        setIsPanoramaOpen(state => ! state);
    }, [ setIsPanoramaOpen ]);

    const isMskMO = offer?.location?.isMskMO ?? false;
    const isSPbLO = offer?.location?.isSPbLO ?? false;
    // const isMskMOSPbLO = isMskMO || isSPbLO;
    const regionId = offer.location.narrowRegion?.id ?? RegionIdEnum.MSK;
    const isSamoletRegion = checkRegionIsPromoSamolet(regionId);

    const bannerRight = getBannerConfig(BannerType.CL_OFFER_RIGHT_DESKTOP);
    const bannerBottom = getBannerConfig(BannerType.CL_OFFER_BOTTOM_DESKTOP);

    const {
        name: developerWithPromoName,
        config: developerPromoConfig
    } = useDeveloperPromo(
        // eslint-disable-next-line no-nested-ternary
        isMskMO ? RegionIdEnum.MSK_AND_MSK_OBL :
            isSPbLO ? RegionIdEnum.SPB_AND_LEN_OBL :
                offer?.location?.narrowRegion?.id
    );

    // const isSamolet = useMemo(
    //     () => offer.newBuildingCard?.developerCards
    //         .some(developerCard => developerCard.developer?.isSamolet) ?? false,
    //     [ offer.newBuildingCard?.developerCards ]
    // );

    const banners = useMemo<{
        square?: DeveloperBanner;
        horizontal?: DeveloperBanner;
    }>(() => {
        if (dealType?.__typename !== 'ProfOfferDealSell' || realtyObject?.__typename !== 'ProfOfferFlat') {
            return {};
        }

        if (developerWithPromoName === 'samolet') {
            // let developerBanners = developerPromoConfig?.banners
            //     .filter(({ id }) => isSamolet ? ! id : id) ?? [];
            //
            // if (developerBanners.length === 0) {
            //     developerBanners = developerPromoConfig?.banners ?? [];
            // }

            const developerBanners = developerPromoConfig?.banners ?? [];

            return {
                square: pickRandom(developerBanners),
                horizontal: pickRandom(developerBanners)
            };
        }

        return {};
    }, [ dealType?.__typename, realtyObject?.__typename, developerWithPromoName, developerPromoConfig ]);

    const variantForOtherRegions = ! regionsEnumeration.has(regionId);

    const router = useRouter();
    // const handleClickOnBreadcrumb = useCallback(
    //     (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    //         if (href === '/') return;
    //         e.preventDefault();
    //         router.update(href);
    //     },
    //     [ router ]
    // );

    const handleMinimalMortgagePayment = useCallback(
        (value: string) => {
            setMinimalMortgagePayment(value);
        },
        [ setMinimalMortgagePayment ]
    );

    const developerCardUrl = useMemo(
        () => isNewBuildingDeveloperFlat ? offer.newBuildingCard?.developerCards?.[0]?.developer?.url : undefined,
        [ offer.newBuildingCard?.developerCards, isNewBuildingDeveloperFlat ]
    );

    const searchRoute = router.route(SearchRoute);
    const floorFlatRoom = useMemo(() => {
        return (offer.realtyObject?.__typename === 'ProfOfferFlat' && offer.realtyObject.floor) ??
            (offer.realtyObject?.__typename === 'ProfOfferRoom' && offer.realtyObject.enclosingFlat?.floor);
    }, [ offer.realtyObject ]);
    const floorTotalFlatRoom = useMemo(() => {
        return (offer.realtyObject?.__typename === 'ProfOfferFlat' && offer.realtyObject.building?.floorsTotal) ??
            (offer.realtyObject?.__typename === 'ProfOfferRoom' && offer.realtyObject.enclosingFlat?.building?.floorsTotal);
    }, [ offer.realtyObject ]);
    const searchSeoChpuMapper = useMemo(() => {
        return new SearchSeoChpuMapper({
            categoryType: offerType,
            dealType: dealTypeEnum,
            last: floorFlatRoom === floorTotalFlatRoom ? 'ONLY' : undefined
        }).chpuMap() as TSearchSeoChpuMapper;
    }, [ offerType, floorTotalFlatRoom, floorFlatRoom, dealTypeEnum ]);
    const generateSearchUrl = useCallback((generateParams: TGenerateSeoUrlParams) => {
        const base: ISearchType = {
            dealType: dealTypeEnum,
            categoryType: offerType,
            region: regionId,
        };

        const params = getSeoSearchRouteParamsByInformationItem({
            searchSeoChpuMapper,
            ...generateParams
        });

        if (! params) return undefined;

        return searchRoute.url({
            ...base,
            ...params
        });
    }, [ dealTypeEnum, offerType, regionId, searchRoute, searchSeoChpuMapper ]);

    useOfferTypeAnalytics({
        isNewBuilding,
        hasAnyPriority,
        offerId: offer.id,
        organizationName: seller.organizationName
    });

    const offerNearestMapLoad = useOfferNearestMapLoader();
    const rooms = roomsType ? [ roomsType ] : undefined;

    if (roomsType === Rooms.STUDIO) rooms?.push(Rooms.ROOM_1);
    if (roomsType === Rooms.ROOM_1) rooms?.push(Rooms.STUDIO);

    const nearest = useOfferNearestMapState({
        offerNearestMapLoad,
        offerId: offer.id,
        center: coordinates ?? undefined,
        multiOfferUrlParams: {
            region: regionId,
            dealType: dealTypeEnum,
            categoryType: offerType,
            ...(realtyObject?.__typename !== 'ProfOfferRoom' && { rooms })
        },
        delta: { x: 0.01, y: 0.005 },
        dealType: dealTypeEnum
    });

    const lastUpdate = isDeleted || ! offer.status?.createdActualizeFormatted ? null : (
        <Typography color='secondary' className={cn('lastUpdate')}>
            {offer.status?.createdActualizeFormatted}
        </Typography>
    );

    const buildingClass = offer.newBuildingCard?.buildingClass?.value;
    const buildingClassBadge = buildingClass ? (
        <Typography
            variant='secondary-alone'
            color='white-500'
            className={cn('buildingClassBadge', { buildingClass })}
        >
            {offer.newBuildingCard?.buildingClass?.fullLabel}
        </Typography>
    ) : null;

    let infoNode: React.ReactNode;
    const segmentMainInfo: React.ReactNode[] = [];
    const priceValue = price?.rubPrice ?? price?.value ?? 0;
    const mapBlockRef = useRef<HTMLDivElement | null>(null);

    const history = price?.history ?? undefined;

    // const newBuildingEmailExtra = useMemo(() => {
    //     if (isNewBuilding || ! isMskMOSPbLO) return '';
    //     return formatCallbackMailExtra(offer, 'offer');
    // }, [ isMskMOSPbLO, isNewBuilding, offer ]);

    const newsList = offer.newBuildingCard?.news ?? [];

    const isPromoOnlinePurchaseVisible = (
        ! isNewBuilding &&
        ! isPit &&
        dealType?.__typename === 'ProfOfferDealSell'
    );

    const isPromoOnlinePurchaseMiniVisible = isPromoOnlinePurchaseVisible;
    const isRepair = false;

    const loadRate = useMinimalMortgageRateLoader();

    const { rate: minimalMortgageRate } = loadRate({
        regionId: offerRegionToMortgage(regionId),
        cost: price?.value,
        isNewBuilding,
    });

    const [ cookie ] = useCookies();
    const variant = cookie?.['ab-testing']?.['mortgage-calculator-a/b-test'];

    const showMortgageBuyOrDie = regionsEnumeration.has(regionId);
    const mortgageCalculator = offer.isMortgageAllowed && price ?
        (
            <div
                ref={mortgageCalculatorRef}
                className={cn('bankMortgage')}
            >
                {variant === 'A' ? (
                    <ClMortgageCalculator
                        price={priceValue}
                        priceCurrency={price?.rubPrice ? Currency.RUB : price?.currency}
                        isNewBuilding={isNewBuilding}
                        regionId={regionId}
                        realtyType={offer.realtyObject?.__typename}
                        scrollToSimilar={scrollToSimilarOffers}
                    />
                ) : (
                    <Mortgage3Calc
                        withoutForm
                        isPreferentialNbCondition={isNewBuilding}
                        realtyType={offer.realtyObject?.__typename}
                        regionId={regionId}
                        purpose={offer.mortgagePurpose}
                        locationPlacement='калькулятор'
                        applicationId={ApplicationIdEnum.ClassifiedDesktop}
                        propertyCost={priceValue}
                        ownAmount={priceValue * 0.2}
                        term={20}
                        gtmStarterModalSendedId='classified_card_sale_ipoteka_banks'
                        gtmShowMoreClick='classified_card_sale_view_ipoteka_call_back'
                        gtmCommonClick={ClassifiedAnalytics.IpotekaFromOffer}
                        gtmSendClick='classified_card_sale_view_ipoteka_banks'
                        buyOrDieMode={showMortgageBuyOrDie}
                        roomType={roomsType}
                        isNewBuilding={isNewBuilding}
                        minimalMortgagePaymentSendData={handleMinimalMortgagePayment}
                        minimalMortgageRate={minimalMortgageRate}
                    />
                )}
            </div>
        ) :
        undefined;

    const rootRegion = useGeoRootRegion();
    const schoolsRating = useMemo(() => (
        offer.ratedSchools.length > 0 ? (
            <div className={cn('schoolList')}>
                {offer.ratedSchools.map(school => (
                    <Typography key={school}>
                        {`\u2013\u00A0\u00A0${school};`}
                    </Typography>
                ))}
                <Typography variant='secondary-alone' color='black-400' className={cn('schoolList')}>
                    По&nbsp;данным Департамента образования и&nbsp;науки&nbsp;г.&nbsp;Москвы в&nbsp;2017-2018&nbsp;гг.
                </Typography>
            </div>
        ) : null
    ), [ offer.ratedSchools ]);

    const infoInfrastructure = useMemo(() => {
        // Костыль, т.к api ratedSchools может вернуть хорошие школы,
        // а в infrastructureEntitiesList может не быть школ и наоборот, поэтому сейчас отдаем приоритет ratedSchools
        const school = 'SCHOOL';
        const isRatedSchools = offer.ratedSchools?.length > 0;
        const includeSchool = offer.infrastructureEntitiesList?.includes(school);

        if (isRatedSchools) {
            if (! includeSchool) {
                offer.infrastructureEntitiesList?.push(school);
            }
        } else {
            if (includeSchool) {
                offer.infrastructureEntitiesList = offer.infrastructureEntitiesList
                    ?.filter((i: string) => i !== school);
            }
        }

        const dataInfrastructure = buildInfoInfrastructure({
            infrastructure: offer.infrastructureEntitiesList,
            yardEntityList: offer.yardEntityList,
            buildB2cInfo: true,
            isPluralForm: offer.ratedSchools?.length > 1,
            generateUrl: generateSearchUrl
        });

        return dataInfrastructure ? dataInfrastructure.map(item => {
            if (item.key === 'goodSchools') {
                return (<DescriptionCell
                    className={cn('infoCell', { infrastructureBlock: true })}
                    key={item.key}
                    data={item}
                    withoutTitle
                    dropdown={offer.ratedSchools.length > 0 ?
                        <>
                            <Typography>
                                Школы в&nbsp;этом районе входят ТОП-399 школ в&nbsp;Москве:
                            </Typography>
                            {schoolsRating}
                        </> : undefined
                    }
                />);
            }

            return (<DescriptionCell
                className={cn('infoCell', { infrastructureBlock: true })}
                key={item.key}
                data={item}
                withoutTitle
            />);
        }) : null;
    }, [ offer, generateSearchUrl, schoolsRating ]);

    const infrastructureBlock = infoInfrastructure && infoInfrastructure.length ? (
        <div className={cn('infoInfrastructure')}>
            <Typography variant='primary-alone' bold className={cn('reset-h')}>
                Недалеко от дома находятся:
            </Typography>
            <Grid cols={3}>
                {infoInfrastructure}
            </Grid>
        </div>
    ) : null;

    // const trackBuildingButton = <TrackBuildingButton offer={offer} />;

    const onVisible = useCallback(() => {
        dataLayerPush({ event: 'classified_im_trade_banner_view' });
    }, [ dataLayerPush ]);

    useGtmOnVisible({ containerRef, onVisible });

    const onMarkdownInfo = useCallback((arr: ReturnType<(<T>() => T)>[]) => {
        if (! arr.length) return null;

        const node = (<div className={cn('additionalDataInfoFlat')}>
            {arr.map((item, idx) => (
                item ? <div
                    key={`additionalDataInfoFlat-item-${idx}`}
                    className={cn('additionalDataInfoFlatItem')}
                    data-test='infoItem'
                >
                    <div data-test='infoItemTitle' style={{ margin: 0, padding: 0 }}>
                        <Typography variant='secondary' color='black-400'>
                            {item?.title}
                        </Typography>
                    </div>
                    <div data-test='infoItemValue' style={{ margin: 0, padding: 0 }}>
                        <Typography
                            tag={item?.url ? 'a' : 'div'}
                            href={item?.url ?? undefined}
                            variant='primary'
                        >
                            {item?.title === 'Комнатность' ? `${item?.value}-комнатная` : item?.value}
                        </Typography>
                    </div>
                </div> : null
            ))}
        </div>);

        return (
            <ExpandableInfo
                size={arr.length}
                node={node}
            />
        );
    }, [ ]);

    switch (realtyObject?.__typename) {
        case 'ProfOfferFlat': {
            const newBuildingId = realtyObject.building?.newBuildingId;

            const dataInfoFlat = mainBuildInfoFlat(
                realtyObject,
                dealType?.__typename === 'ProfOfferDealRent' ? dealType.livingTenantRequirements : undefined,
                {
                    isNewBuilding,
                    useB2cFuncs: true,
                    withApartment: true,
                    generateUrl: generateSearchUrl
                }
            );

            const additionalDataInfoFlat = additionalBuildInfoFlat(
                realtyObject,
                dealType?.__typename === 'ProfOfferDealRent' ? dealType.livingTenantRequirements : undefined,
                {
                    isNewBuilding,
                    useB2cFuncs: true,
                    withApartment: true,
                    generateUrl: generateSearchUrl
                }
            );

            // isRepair = dealType?.__typename === 'ProfOfferDealSell' &&
            //     dataInfoFlat.some(({ icon }) => icon === InformationsIconEnum.renovationNeed || icon === InformationsIconEnum.renovationRough);

            const dataInfoBuilding = buildInfoBuilding(
                realtyObject,
                offer.infrastructure ?? undefined,
                {
                    isRenovationProgram: offer.renovationProgram,
                    buildEpoch: offer.buildEpoch,
                    buildSeries: offer.buildingSeries,
                    buildHeating: offer.heatingType,
                    buildB2cInfo: true,
                    generateUrl: generateSearchUrl
                }
            );

            const infoFlat = dataInfoFlat.map(item => (
                <DescriptionCell
                    className={cn('infoCell')}
                    key={item.key}
                    data={item}
                />
            ));

            const additionalInfoFlat = onMarkdownInfo(additionalDataInfoFlat);

            // const infoBuilding = dataInfoBuilding.map(item => (
            //     <DescriptionCell
            //         className={cn('infoCell')}
            //         key={item.key}
            //         data={item.key === InformationsEnum.finishQuarter ?
            //             { ...item, value: <TooltipUnderline value={item.value} title='По данным m2.ru' /> } :
            //             item
            //         }
            //         dropdown={(item.key === 'buildHeatingType' && item.value === 'домовая котельная') ? (
            //             <>В&nbsp;домах с&nbsp;собственной домовой котельной нет сезонного отключения горячей воды</>
            //         ) : undefined}
            //     />
            // ));

            const infoBuilding = onMarkdownInfo(dataInfoBuilding);

            if (! realtyObject.building?.newBuildingStatus?.builtYear && realtyObject.building?.newBuildingStatus?.formattedInProgress) {
                segmentMainInfo.push(
                    <StaticSectionItem
                        key='Срок сдачи'
                        label='Срок сдачи'
                    >
                        {'Строится до\u00A0'}{realtyObject.building?.newBuildingStatus?.formattedInProgress}
                    </StaticSectionItem>
                );
            }

            const [ phoneNumber, setPhoneHumber ] = useState(null);

            useEffect(() => {
                if (! phoneNumber && phone.phoneFormatted) {
                    setPhoneHumber(phone.phoneFormatted);
                }
            }, [ phone.phoneFormatted, phoneNumber ]);

            const showPhoneNumber = () => {
                ! phoneNumber && phone.load({ offerId: offer.id }).then(() => {
                    dataLayerPush({ event: 'classified_im_trade_banner_show_tel' });
                });
            };

            infoNode = (
                <>
                    {dataInfoFlat.length > 0 && (
                        <div className={cn('wrap')}>
                            {isPit && (
                                <PitBannerDesktop
                                    showPhoneNumber={showPhoneNumber}
                                    phoneFormatted={phone.phoneFormatted}
                                    phoneRef={phone.phoneHref}
                                />
                            )}
                            <div className={cn('mainInfoItems')}>
                                <Grid
                                    cols={3}
                                    gap
                                    variables={{
                                        '--row-gap-xl': '32px'
                                    }}
                                >
                                    {infoFlat}
                                </Grid>
                            </div>
                            {isNewBuilding && newBuilding && newBuilding.specialEvents?.length ? (
                                <div
                                    className={cn('row', { anchor: true })}
                                >
                                    <NewBuildingSpecialEventsHeading
                                        title='Акции и скидки'
                                        subtitle={newBuilding?.title.locative}
                                        seoTitle={newBuilding?.seo.seoTitle}
                                    />
                                    <NewBuildingSpecialEvents
                                        specialEvents={newBuilding.specialEvents}
                                        newBuildingTitle={newBuilding?.title.nominative}
                                        developerTitle={newBuilding.developerCards[0]?.developer?.title}
                                        callBtn={<Button
                                            fullWidth
                                            disabled={phone.loading}
                                            loading={phone.loading}
                                            onClick={handlePhoneLoadTop}
                                            dataTest='offer-phone-call-1'
                                            variant={shouldShowVasBlock || variantForOtherRegions ? 'secondary' : 'primary'}
                                        >Показать телефон</Button>}
                                    />
                                </div>
                            ) : null}
                            <Typography variant='h2' tag='h2' className={cn('reset-h')}>
                                Описание
                            </Typography>
                            {getApartments(realtyObject) ? (
                                <div className={cn('apartmentDescription')}>
                                    <Typography itemProp='description' variant='primary'>
                                        {/* eslint-disable-next-line max-len */}
                                        Апартаменты не относятся к жилому фонду, но имеют необходимые условия для
                                        проживания. В апартаментах нельзя оформить регистрацию по месту жительства.
                                        Такие квартиры дешевле, но коммунальные платежи выше.
                                    </Typography>
                                    <Icon name='information-circle' color='rgb(164, 161, 181)' />
                                </div>
                            ) : null}
                            {offer?.description &&
                                <ExpandableDescription description={offer?.description} isDeleted={isDeleted} />}
                            {lastUpdate}
                            {/*{! isNewBuilding && isSellFlat && (*/}
                            {/*    <OfferPhoneModal2Link onClick={handlePhoneLoadLink} />*/}
                            {/*)}*/}
                        </div>
                    )}
                    {additionalInfoFlat}
                    {mortgageCalculator}
                    {infoBuilding && (<>
                        <Typography variant='h2' tag='h2' className={cn('reset-h')}>
                            Описание дома
                        </Typography>
                        {/*<Grid cols={3}>*/}
                        {/*    {infoBuilding}*/}
                        {/*</Grid>*/}
                        {infoBuilding}
                        {/*{isNewBuilding && (*/}
                        {/*    <div className={cn('track-building-button')}>{trackBuildingButton}</div>*/}
                        {/*)}*/}
                    </>)}
                    {Boolean(newBuildingId) && (<>
                        <NewBuildingMiniCard
                            skipFlats={dealType?.__typename === 'ProfOfferDealRent'}
                            key='NewBuildingMiniCard'
                            newBuilding={offer.newBuildingCard}
                            gtmClick='cl_ToNB_card_to_ZK_special_block'
                        />
                        {newsList.length > 0 ? (
                            <NewBuildingNews
                                heading={
                                    <NewBuildingSectionHeading
                                        title='Новости'
                                        subtitle={offer.newBuildingCard?.title.genitive ?? ''}
                                        seoTitle={offer.newBuildingCard?.seo.seoTitle ?? ''}
                                    />
                                }
                                onClickNewsItem={() => {
                                    dataLayerPush({ event: 'classified_news_click_open_news_report' });
                                }}
                                news={newsList}
                            />
                        ) : null}
                    </>
                    )}
                </>
            );

            break;
        }
        case 'ProfOfferRoom': {
            const dataInfoRoom = buildMainInfoRoom(
                realtyObject,
                dealType?.__typename === 'ProfOfferDealRent' ? dealType.livingTenantRequirements : undefined,
                {
                    isRent: dealType?.__typename === 'ProfOfferDealRent',
                    useB2cFuncs: true,
                    generateUrl: generateSearchUrl
                }
            );

            const additionalDataInfoFlat = buildAdditionalInfoRoom(
                realtyObject,
                dealType?.__typename === 'ProfOfferDealRent' ? dealType.livingTenantRequirements : undefined,
                {
                    isNewBuilding,
                    useB2cFuncs: true,
                    withApartment: true,
                    generateUrl: generateSearchUrl
                }
            );

            const dataInfoBuilding = buildInfoBuilding(
                realtyObject?.enclosingFlat ?? undefined,
                offer.infrastructure ?? undefined,
                undefined,
                {
                    isRenovationProgram: offer.renovationProgram,
                    buildB2cInfo: true
                }
            );

            const additionalInfoFlat = onMarkdownInfo(additionalDataInfoFlat);

            // const offerredRooms = realtyObject?.roomCount ?? undefined;

            const infoRoomFlat = dataInfoRoom.map(item => (
                <DescriptionCell
                    key={item.key}
                    className={cn('infoCell')}
                    data={item}
                />
            ));

            // const infoBuilding = dataInfoBuilding.map(item => (
            //     <DescriptionCell
            //         className={cn('infoCell')}
            //         key={item.key}
            //         data={item}
            //     />
            // ));

            const infoBuilding = onMarkdownInfo(dataInfoBuilding);

            infoNode = (
                <>
                    {dataInfoRoom.length > 0 && (
                        <>
                            <div className={cn('wrap')}>
                                <div className={cn('mainInfoItems')}>
                                    <Grid
                                        cols={3}
                                        gap
                                        variables={{
                                            '--row-gap-xl': '32px'
                                        }}
                                    >
                                        {infoRoomFlat}
                                    </Grid>
                                </div>
                                <Typography variant='h2' tag='h2' className={cn('reset-h')}>
                                    Описание
                                </Typography>
                                {offer?.description && <ExpandableDescription description={offer?.description} /> }
                                {lastUpdate}
                            </div>
                            {additionalInfoFlat}
                            {mortgageCalculator}
                            {dataInfoBuilding.length > 0 && (<>
                                <Typography variant='h2' tag='h2' className={cn('reset-h')}>
                                    Описание дома
                                </Typography>
                                {infoBuilding}
                            </>)}
                        </>
                    )}
                </>
            );

            break;
        }

        case 'ProfOfferLand': {
            const landInfo = buildMainInfoLand(
                realtyObject,
                {
                    useLandIcon: true,
                    generateUrl: generateSearchUrl
                }
            );

            const landAdditionalInfo = buildAdditionalInfoLand(
                realtyObject,
                dealType?.__typename === 'ProfOfferDealRent' ? dealType.livingTenantRequirements : undefined,
                {
                    useLandIcon: true,
                    generateUrl: generateSearchUrl
                }
            );

            const additionalLandInfo = onMarkdownInfo(landAdditionalInfo);

            const infoLand = landInfo.map(item => (
                <DescriptionCell
                    className={cn('infoCell')}
                    key={item.key}
                    data={item}
                />
            ));

            const isShowLandInfo = infoLand.length > 0;

            landInfo.forEach(({ key, value }) => {
                if (key === InformationsEnum.landStatus) {
                    segmentMainInfo.push(
                        <StaticSectionItem key={key} value={value} label='Статус участка' />
                    );
                }
            });

            infoNode = (
                <>
                    <div className={cn('wrap')}>
                        {
                            isShowLandInfo &&
                            <>
                                <div className={cn('mainInfoItems')}>
                                    <Grid
                                        cols={3}
                                        gap
                                        variables={{
                                            '--row-gap-xl': '32px'
                                        }}
                                    >
                                        {infoLand}
                                    </Grid>
                                </div>
                                <Typography variant='h2' tag='h2' className={cn('reset-h')}>
                                    Описание
                                </Typography>
                            </>
                        }
                        {offer?.description && <ExpandableDescription description={offer?.description} /> }
                        {lastUpdate}
                        {additionalLandInfo}
                    </div>
                    {
                        offer.isMortgageAllowed && price ? (
                            <div ref={mortgageCalculatorRef}>
                                <LandMortgage
                                    propertyCost={priceValue}
                                    regionId={regionId}
                                />
                            </div>
                        ) : null
                    }
                </>
            );
            break;
        }

        case 'ProfOfferHouse': {
            const mainHouseInfo = buildMainInfoHouse(
                realtyObject,
                { useB2cFunc: true, generateUrl: generateSearchUrl }
            );

            const additionalHouseInfo = buildAdditionalInfoHouse(
                realtyObject,
                dealType?.__typename === 'ProfOfferDealRent' ? dealType.livingTenantRequirements : undefined,
                { useB2cFunc: true, generateUrl: generateSearchUrl }
            );

            const infoHouse = mainHouseInfo.map(item => (
                <DescriptionCell
                    className={cn('infoCell')}
                    key={item.key}
                    data={item}
                />
            ));

            const infoAdditionalHouse = onMarkdownInfo(additionalHouseInfo);

            mainHouseInfo.forEach(({ key, value }) => {
                if (key === InformationsEnum.landStatus) {
                    segmentMainInfo.push(
                        <StaticSectionItem key={key} value={value} label='Статус участка' />
                    );
                }
            });

            additionalHouseInfo.forEach(({ key, value }) => {
                if (key === InformationsEnum.houseFloors) {
                    segmentMainInfo.push(
                        <StaticSectionItem key={key} value={value} label='Этажность' />
                    );
                }
            });

            infoNode = (<>
                <div className={cn('wrap')}>
                    {
                        infoHouse.length > 0 &&
                        <>
                            <div className={cn('mainInfoItems')}>
                                <Grid
                                    cols={3}
                                    gap
                                    variables={{
                                        '--row-gap-xl': '32px'
                                    }}
                                >
                                    {infoHouse}
                                </Grid>
                            </div>
                            <Typography variant='h2' tag='h2' className={cn('reset-h')}>
                                Описание
                            </Typography>
                        </>
                    }
                    {offer?.description && <ExpandableDescription description={offer?.description} /> }
                    {lastUpdate}
                    {infoAdditionalHouse}
                </div>
                {mortgageCalculator}
            </>);
            break;
        }

        default: {
            return null;
        }
    }

    // const renovation = renovationCompat(realtyObject);
    const routesList = offer.location?.routesList;
    const route = routesList?.length ? routesList[0] : undefined;
    //eslint
    const geos: SeoGeos[] = React.useMemo(() => [], []);
    const wideDistrict = offer.location?.wideDistrict;
    const regionLocative = rootRegion.byId(regionId);

    if (route?.station) {
        geos.push({
            kind: GeoKind.METRO,
            id: route.station.id,
            title: route.station.name
        });
    }
    if (wideDistrict) {
        geos.push({
            kind: GeoKind.DISTRICT,
            id: wideDistrict.id,
            title: wideDistrict.name
        });
    }

    // const sections = useOfferDetailsBreadcrumbSections({
    //     region: regionId,
    //     dealType: dealTypeEnum,
    //     categoryType: offerType,
    //     rooms: roomsType ? [ roomsType ] : [],
    //     renovation: renovation ? [ renovation ] : [],
    //     title: offer.text?.titleCard,
    //     rootRegion: regionLocative,
    //     geos
    // });

    const onSwitchToNb = useCallback(() => {
        window.scrollTo(0, 0);

        searchRoute.push({
            region: regionId,
            dealType: dealTypeEnum,
            categoryType: offerType,
            rooms: roomsType ? [ roomsType ] : [],
            title: offer.text?.titleCard,
            rootRegion: regionLocative,
            newBuilding: [ NewBuilding.NEW ],
            geos
        });
    }, [
        dealTypeEnum,
        geos,
        offer.text?.titleCard,
        offerType,
        regionId,
        regionLocative,
        roomsType,
        searchRoute
    ]);

    const thumbnails = useMemo(() => {
        return offer.gallery?.images
            .map((photo, index) => ({
                id: `${index}`,
                originPath: photo.originPath,
                description: offer.text?.titleCard,
                attributesType: photo.attributesType
            }) as IImage);
    }, [ offer.gallery, offer.text ]);

    const showDeveloperBadge = dealType?.__typename === 'ProfOfferDealSell' && isNewBuildingDeveloperFlat;

    const showBadgeTextBox = isNewBuilding || showDeveloperBadge;

    const moderatorExtension = (
        <ModeratorExtension id={offer.id} />
    );

    const staticSectionRef = useRef<HTMLDivElement | null>(null);
    const [ showFloatingBlock, setShowFloatingBlock ] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (! entry.isIntersecting) {
                    setShowFloatingBlock(true);
                } else {
                    setShowFloatingBlock(false);
                }
            });
        });
        const el = staticSectionRef.current;

        if (el) {
            observer.observe(el);
        }

        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        trackOfferView(offer.id);
        if (dealType?.__typename === 'ProfOfferDealRent') {
            dataLayerPush({ event: 'classified_rent_flat_open_second_offer', offerId: offer.id });
        }
    }, [ offer.id, trackOfferView, dealType?.__typename, dataLayerPush ]);

    const { offerUrl } = useOfferCardLink(offer);
    const galleryMortgageBanner = offer.isMortgageAllowed && price ? (
        <MortgageStupidBanner
            realtyType={offer.realtyObject?.__typename}
            gtmSendId='classified_card_sale_ipoteka_gallery'
            gtmShowId='classified_card_sale_view_ipoteka_gallery'
            locationPlacement='галерея'
            regionId={regionId}
            offerUrl={offerUrl}
            isNewBuilding={isNewBuilding}
            applicationId={ApplicationIdEnum.ClassifiedDesktop}
            minimalMortgageRate={minimalMortgageRate}
        />
    ) : null;

    const repairBanner = isRepair && totalArea?.value ? (
        <DesktopRepairGalleryBanner area={totalArea?.value} />
    ) : null;

    // const showCallbackButton = (
    //     (isNewBuilding && isMskMOSPbLO && seller.sellerType === SellerType.DEVELOPER) ||
    //     offer.status?.hasAnyPriority
    // ) && ! variantForOtherRegions;
    // const showMortgageButton = ! showCallbackButton && Boolean(price) && offer.isMortgageAllowed;

    const stats = offer.stats;
    const offerViews = stats?.all?.offerViews ?? 0;
    const offerViewsPerDay = stats?.today?.offerViews ?? 0;

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [ showInfrastructure, setShowInfrastructure ] = useState(true);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [ isFullscreenMap, setFullscreenMap ] = useState(false);
    const favoriteButton = ! isDeleted && ! isMyOffer && offer.isFavoriteVisible && offer.isFavorite !== null ?
        (
            ! favorites.isProfessional ? (
                <FavoritesButton
                    onClick={favorites.favoriteToggle}
                    isActive={favorites.isFavorite}
                    circle
                    variant='secondary'
                />
            ) : (
                <AgentFavoritesDropdown
                    isMyFavorite={favorites.isFavorite}
                    offerId={offer.id}
                    onChangeMyFavorite={(v) => favorites.updateFavorite({
                        isFavorite: v
                    })}
                    renderTrigger={({ handleToggle }) => (
                        <FavoritesButton
                            isActive={favorites.isFavorite}
                            onClick={handleToggle}
                            circle
                            variant='secondary'
                        />
                    )}
                />
            )
        ) :
        undefined;

    const isYandexBanner = false; // RS-7201: ya-banners disabling
    // const isYandexBanner = realtyObject.__typename !== 'ProfOfferFlat' || dealType?.__typename !== 'ProfOfferDealSell';

    const isMortgage2StarterLink = price && ! isPromoOnlinePurchaseVisible;

    if (! (isNewBuilding || newBuilding)) {
        return (
            <NotFoundPage />
        );
    }

    return (<>
        {isDeleted ? <div className={cn('deleted', undefined, 'colored-app-paddings')}>
            Объявление снято с публикации
        </div> : null }
        <div
            className={cn('flex')}
            data-test='offer'
            id={`offer-${offer.id}`}
            itemScope
            itemType={'http://schema.org/Product'}
        >
            {/* <Breadcrumb
                className={cn('breadcrumb')}
                onClick={handleClickOnBreadcrumb}
                sections={sections}
            /> */}
            <div className={cn('content')}>
                <div className={cn('left')}>
                    <div style={{ display: 'flex' }}>
                        {showBadgeTextBox && (
                            <Typography bold className={cn('badgesText')}>
                                {`${isNewBuilding && 'Новостройка '}${showDeveloperBadge ? 'от застройщика' : ''}`}
                            </Typography>
                        )}
                        {! offerViews ? undefined : (
                            <OfferStatView offerViews={offerViews} offerViewsPerDay={offerViewsPerDay} />
                        )}
                    </div>
                    <Typography variant='h1' tag='h1' itemProp='name' className={cn('reset-h')}>
                        {offer.text?.titleCard}
                    </Typography>

                    <div className={cn('location')}>
                        <div className={cn('address')}>
                            <ClClickableAddress
                                isCopiable
                                addresses={addresses}
                                metersToCenterText={metersToCenterText}
                                formattedAddressLong={offer.location.formattedAddressLong ?? ''}
                                noClickable
                            />
                        </div>
                        <div className={cn('metro')}>
                            <OfferRouteCardList offerRoutes={offerRoutes} noClickable />
                        </div>
                    </div>

                    {userId && shouldShowVasBlock && (<div className={cn('order-offer-vas')}>
                        <ClOrderOfferCardVas
                            offerId={offer.id}
                            regionId={regionId}
                            userPhone={userPhone}
                        />
                    </div>)}

                    <div className={cn('gallery-wrapper')}>
                        <GalleryOfferCard
                            offerTitle={offer?.text?.titleCard}
                            mapRef={mapBlockRef}
                            isPledge={isPledge}
                            isPit={isPit}
                            onlineView={onlineView}
                            className={cn('gallery')}
                            starterBanner={galleryMortgageBanner}
                            repairBanner={repairBanner}
                            hasTopPriority={offer.status?.hasTop}
                            hasHighlightPriority={offer.status?.hasHighlight}
                            onOpenPanorama={togglePanorama}
                            thumbnails={thumbnails ?? []}
                            isShowPanorama={(
                                realtyObject.__typename === 'ProfOfferFlat' ||
                                realtyObject.__typename === 'ProfOfferRoom'
                            )}
                        />
                    </div>
                    {infoNode}
                    {/*{ ! isNewBuilding &&*/}
                    {/*    (realtyObject?.__typename === 'ProfOfferRoom' ||*/}
                    {/*        realtyObject?.__typename === 'ProfOfferFlat') &&*/}
                    {/*    (*/}
                    {/*        <div className={cn('buildingRelated')}>*/}
                    {/*            <OfferTinySnippetList*/}
                    {/*                offer={offer}*/}
                    {/*                addresses={addresses}*/}
                    {/*                renderTrackBuildingButton={trackBuildingButton}*/}
                    {/*            />*/}
                    {/*        </div>*/}
                    {/*    )*/}
                    {/*}*/}
                    <Typography variant='h2' tag='h2' className={cn('mapTitle')}>
                        На карте
                    </Typography>
                    <div
                        className={cn('mapBlock', { infrastructureBlock: Boolean(infrastructureBlock) })}
                        ref={mapBlockRef}
                    >
                        <YMapDesktop
                            noZoom
                            noPlacemark
                            useChangedMargin
                            bounds={nearest.bounds}
                            setBounds={nearest.setBounds}
                            regionId={regionId}
                            showInfrastructure={showInfrastructure}
                        >
                            {/* https://jira.m2.ru/browse/RS-7469 */}
                            {/*<Checkbox*/}
                            {/*    checked={showInfrastructure}*/}
                            {/*    onChange={checked => setShowInfrastructure(checked)}*/}
                            {/*    className={cn('infrastructure', { fullscreen: isFullscreenMap })}*/}
                            {/*>*/}
                            {/*    Инфраструктура*/}
                            {/*</Checkbox>*/}
                            <YMapControlGroup
                                hAlign='right'
                                vAlign='bottom'
                                layout='vertical'
                                size='mChangedMargin'
                            >
                                <YMapControlCentering title='Переместить к объявлению' />
                            </YMapControlGroup>
                            <YMapControlGroup
                                hAlign='right'
                                vAlign='top'
                                layout='vertical'
                                size='mChangedMargin'
                            >
                                <YMapControlFullscreen setFullscreen={setFullscreenMap} title='Развернуть карту' />
                            </YMapControlGroup>
                            {(
                                realtyObject.__typename === 'ProfOfferFlat' ||
                                realtyObject.__typename === 'ProfOfferRoom'
                            ) && (
                                <YMapControlGroup
                                    hAlign='left'
                                    vAlign='bottom'
                                    layout='vertical'
                                    size='mChangedMargin'
                                >
                                    <YMapControlPanorama title='Панорама улицы' onOpen={togglePanorama} />
                                </YMapControlGroup>
                            )}
                            {/*{nearest.tileUrl && <YMapLayer tileUrl={nearest.tileUrl} />}*/}
                            {/*{nearest.responseItems?.map(item => <OfferYMapUnionPlacemark*/}
                            {/*    item={item}*/}
                            {/*    key={item.id}*/}
                            {/*/>)}*/}
                            <YMapPlacemarkPoint point={coordinates ? [
                                coordinates.latitude,
                                coordinates.longitude
                            ] : undefined} />
                        </YMapDesktop>
                    </div>
                    {isYandexBanner && (<YandexBanner variant='offer-map-desk' />)}
                    {infrastructureBlock}
                    <Typography
                        color='secondary'
                        variant='primary'
                        className={cn('seoText', { infrastructureBlock: Boolean(infrastructureBlock) })}
                    >
                        {offer.text?.pageDescription}
                    </Typography>
                </div>

                <div className={cn('right')}>
                    <div
                        className={cn('staticSection', { hasBuildingClass: Boolean(buildingClass) })}
                        ref={staticSectionRef}
                    >
                        {buildingClassBadge}
                        {price && (
                            <Price
                                history={history}
                                priceValue={price?.rubPrice ?? price?.value ?? 0}
                                priceCurrency={price?.rubPrice ? Currency.RUB : price?.currency}
                                rentPeriod={dealTypePeriodCompat(dealType)}
                                variant='h3'
                                bold
                                hasItemProp
                            />
                        )}
                        {price?.rubPrice && (
                            <Price
                                priceValue={price.value}
                                priceCurrency={price.currency}
                                rentPeriod={dealTypePeriodCompat(dealType)}
                                variant='primary-alone'
                                className={cn('currencyOffer')}
                                bold
                                hasItemProp
                            />
                        )}
                        {dealType?.__typename === 'ProfOfferDealSell' && price ? (
                            <>
                                <div className={cn('price-detail')}>
                                    <PriceDetail
                                        variant='primary-alone'
                                        color='secondary'
                                        totalAreaValue={totalArea.value}
                                        totalAreaUnit={totalArea.unit}
                                        priceValue={price.rubPrice ?? price.value}
                                        priceCurrency={price.rubPrice ? Currency.RUB : price.currency}
                                        short
                                    />
                                    {price.rubPrice && (
                                        <>
                                            <span className={cn('price-detail-separator')}>•</span>
                                            <PriceDetail
                                                variant='primary-alone'
                                                color='secondary'
                                                totalAreaValue={totalArea.value}
                                                totalAreaUnit={totalArea.unit}
                                                priceValue={price.value}
                                                priceCurrency={price.currency}
                                                short
                                            />
                                        </>
                                    )}
                                </div>
                            </>
                        ) : null}
                        {/*{price && (<SubscribePriceTooltip*/}
                        {/*    offerId={offer.id}*/}
                        {/*    price={{*/}
                        {/*        value: price.value,*/}
                        {/*        currency: price.currency*/}
                        {/*    }}*/}
                        {/*    hasSubscription={offer.hasSubscription}*/}
                        {/*    setIsFavoriteCurrent={favorites.setIsFavorite}*/}
                        {/*/>)}*/}
                        {dealType?.__typename === 'ProfOfferDealRent' && dealType?.utilities?.formatted && (
                            <Typography
                                color='secondary'
                                className={cn('utilities')}
                            >
                                {dealType.utilities.formatted}
                            </Typography>
                        )}
                        {! isDeleted && (
                            <div className={cn('additional-actions')}>
                                {favoriteButton}
                            </div>
                        )}
                        {offer.isMortgageAllowed && ! isMortgage2StarterLink && minimalMortgagePayment ?
                            <div className={cn('mortgage-price')}>
                                <div className={cn('mortgage-price-heading')}>
                                    В ипотеку:
                                </div>
                                <div
                                    className={cn('mortgage-price-value')}
                                    onClick={scrollToMortgageCalculator}
                                >
                                    от {formatNumber(minimalMortgagePayment)} ₽ в месяц
                                </div>
                            </div> :
                            null
                        }
                        <hr className={cn('hr')} style={{ width: '80px' }} />
                        {isRepair ? <RepairLinks openRepairModal={openRepairModal} /> : null}
                        {offer.isMortgageAllowed && isMortgage2StarterLink ?
                            <Mortgage2StarterLink
                                purpose={offer.mortgagePurpose}
                                gtmSendId='classified_card_sale_ipoteka_link'
                                linkGtmId='classified_card_sale_view_ipoteka_link'
                                propertyCost={priceValue}
                                regionId={regionId}
                                realtyType={offer.realtyObject?.__typename}
                                mortgageBannerMinutesVariant={mortgageBannerMinutesVariant}
                                mortgageBannerTextVariant={mortgageBannerTextVariant}
                                locationPlacement='блок под ценой'
                                applicationId={ApplicationIdEnum.ClassifiedDesktop}
                                scrollToMortgageCalculator={scrollToMortgageCalculator}
                                isABTest
                                variantForOtherRegions={variantForOtherRegions}
                                minimalMortgageRate={minimalMortgageRate}
                            /> :
                            null
                        }
                        {segmentMainInfo}
                        {(
                            (dealType?.__typename === 'ProfOfferDealSell' && dealType.sellTypeFormatted) ||
                            price?.rubPrice ||
                            (
                                dealType?.__typename === 'ProfOfferDealRent' && (
                                    dealType.hasDeposit?.formatted ||
                                    dealType.hasPrepayment?.formatted ||
                                    dealType.commission?.formatted ||
                                    dealType.bargainAllowed?.formatted
                                )
                            )
                        ) && (<>
                            <StaticSectionItemLabel>Условия сделки</StaticSectionItemLabel>
                            {dealType?.__typename === 'ProfOfferDealSell' && dealType.sellTypeFormatted && (
                                <StaticSectionItemValue>{dealType.sellTypeFormatted}</StaticSectionItemValue>
                            )}
                            {price?.rubPrice && (<StaticSectionItemValue>Сделка в валюте</StaticSectionItemValue>)}
                            {dealType?.__typename === 'ProfOfferDealRent' && (<>
                                {dealType.hasDeposit?.formatted && (
                                    <StaticSectionItemValue children={dealType.hasDeposit.formatted} />)}
                                {dealType.hasPrepayment?.formatted && (
                                    <StaticSectionItemValue children={dealType.hasPrepayment.formatted} />)}
                                {dealType.commission?.formatted && (
                                    <StaticSectionItemValue children={dealType.commission.formatted} />)}
                                {dealType.bargainAllowed?.formatted && (
                                    <StaticSectionItemValue children={dealType.bargainAllowed.formatted} />)}
                            </>)}
                        </>)}

                        <div className={cn('staticSection-item-label')}>
                            <CardAuthorBadge
                                iconSrc={seller.icon}
                                name={seller.name}
                                organizationName={seller.organizationName}
                                category={seller.sellerType}
                                url={developerCardUrl}
                            />
                        </div>
                        {isMyOffer ? null : (
                            <div className={cn('actions', { reorder: variantForOtherRegions })}>
                                { ! isDeleted && (
                                    <Button
                                        fullWidth
                                        disabled={phone.loading}
                                        loading={phone.loading}
                                        onClick={handlePhoneLoadTop}
                                        dataTest='offer-phone-call-1'
                                        variant={shouldShowVasBlock || variantForOtherRegions ? 'secondary' : 'primary'}
                                    >Показать телефон</Button>
                                )}
                                { phone.phoneFormatted && phone.phoneHref && isPhoneModalOpened ? (
                                    <OfferPhoneModal2
                                        isNewBuilding={isNewBuilding}
                                        onClose={closePhoneModal}
                                        isSellFlat={isSellFlat}
                                        phoneFormatted={phone.phoneFormatted}
                                        phoneHref={phone.phoneHref}
                                        isDoppelganger={phone.isDoppelganger}
                                        offer={offer}
                                        placeCall={placeCallPhoneModal}
                                    />
                                ) : undefined}
                                {/*<CallToActionButton*/}
                                {/*    showCallbackButton={showCallbackButton}*/}
                                {/*    showMortgageButton={showMortgageButton}*/}
                                {/*    locationPlacement='CTA статичный'*/}
                                {/*    newBuildingCard={offer.newBuildingCard}*/}
                                {/*    offerStatus={offer.status}*/}
                                {/*    offerLocation={offer.location}*/}
                                {/*    newBuildingEmailExtra={newBuildingEmailExtra}*/}
                                {/*    seller={seller}*/}
                                {/*    isNewBuilding={isNewBuilding}*/}
                                {/*    applicationId={ApplicationIdEnum.ClassifiedDesktop}*/}
                                {/*    realtyType={offer.realtyObject?.__typename}*/}
                                {/*/>*/}
                                <OfferCardMortgageButton
                                    scrollToMortgageCalculator={scrollToMortgageCalculator}
                                    isAuth={auth.isAuthenticated}
                                    price={priceValue}
                                    isNewBuilding={isNewBuilding}
                                    regionId={regionId}
                                />
                            </div>
                        )}
                        {! isDeleted && (
                            <div className={cn('mini-buttons')}>
                                <SharePrintButton offerId={offer.id} gtmPrint='cl_print_offer_click' />
                                <ShareButton
                                    textPlacement='tooltip'
                                    preferNativeShare={false}
                                />
                                {! isMyOffer && offer.isFavoriteVisible && offer.isFavorite !== null && (<>
                                    <NotesButton
                                        isActive={Boolean(favorites.noteText)}
                                        onClick={favorites.noteEditOpen}
                                        block
                                        variant='secondary'
                                    />
                                    {favorites.isNoteEditing && (<NotesEditor
                                        noteTextInitial={favorites.noteText}
                                        noteSubmit={favorites.noteSave}
                                        noteDelete={favorites.noteDelete}
                                        onClose={favorites.noteEditClose}
                                    />)}
                                    {auth.isAuthenticated && <HideButton
                                        block
                                        variant='secondary'
                                        isActive={hidden.isHidden}
                                        onClick={hidden.hiddenToggle}
                                    />}
                                </>)}
                                {! isMyOffer && (
                                    <ReportButton offerId={offer.id} />
                                )}
                            </div>
                        )}
                        {isYandexBanner && (
                            <div style={{ marginTop: '24px' }}>
                                <YandexBanner variant='offer-sidebar-desk' />
                            </div>
                        )}
                        {isDeleted || ! offer.status?.createdActualizeFormatted || ! isRgrMember ? null : (
                            <div className={cn('rgrBlock')}>
                                <RgrLogo />
                                <Typography color='black-300' variant='secondary-alone'>
                                    Российская Гильдия Риэлторов
                                </Typography>
                            </div>
                        )}
                        {moderatorExtension && (
                            <div className={cn('moderatorExtension')}>
                                {moderatorExtension}
                            </div>
                        )}
                        {isSamoletRegion && (
                            <div className={cn('fixedBanner')}>
                                <FixedSizeBanner
                                    placementId={bannerRight.placementId}
                                    group={bannerRight.group}
                                />
                            </div>
                        )}
                    </div>
                    <div className={cn('imageBanner', { hidden: showFloatingBlock })}>
                        {banners.square && staticPath && (
                            <ImageBanner
                                view='square'
                                targetLink={`${banners.square.url}?${AnalyticsFromTags.SpecProjectCardCL}`}
                                image={banners.square.image.square}
                                gtm={ClassifiedAnalytics.PromoBannerCardTop}
                                gtmClickData={getDeveloperBannerGtmData(developerWithPromoName, {
                                    action: 'click',
                                    section: 'banner_right',
                                    pageType: 'card'
                                })}
                                gtmShowData={getDeveloperBannerGtmData(developerWithPromoName, {
                                    action: 'view',
                                    section: 'banner_right',
                                    pageType: 'card'
                                })}
                            />
                        )}
                    </div>

                    {isDeleted ? null : (
                        <div className={cn('floatingSection', { show: showFloatingBlock })}>
                            <div className={cn('miniCard', { custom: isPromoOnlinePurchaseMiniVisible })}>
                                <div className={cn('miniCard-top', { custom: isPromoOnlinePurchaseMiniVisible })}>
                                    <div className={cn('miniCard-details')}>
                                        <Price
                                            history={history}
                                            priceValue={price?.rubPrice ?? price?.value ?? 0}
                                            priceCurrency={price?.rubPrice ? Currency.RUB : price?.currency}
                                            rentPeriod={dealTypePeriodCompat(dealType)}
                                            variant='primary-alone'
                                            bold
                                            hasItemProp
                                        />
                                        <Typography className={cn('miniCard-title')}>
                                            {offer.text?.titleCard}
                                        </Typography>
                                    </div>
                                    {favoriteButton}
                                </div>
                                {isMyOffer ? null : (
                                    <div className={cn('actions', { reorder: variantForOtherRegions, custom: isPromoOnlinePurchaseMiniVisible })}>
                                        <Button
                                            fullWidth
                                            disabled={phone.loading}
                                            loading={phone.loading}
                                            onClick={handlePhoneLoadBottom}
                                            dataTest='offer-phone-call-2'
                                            variant={shouldShowVasBlock || variantForOtherRegions ? 'secondary' : 'primary'}
                                        >Показать телефон</Button>
                                        {/*<CallToActionButton*/}
                                        {/*    showCallbackButton={showCallbackButton}*/}
                                        {/*    showMortgageButton={showMortgageButton}*/}
                                        {/*    locationPlacement='CTA плавающий'*/}
                                        {/*    newBuildingCard={offer.newBuildingCard}*/}
                                        {/*    offerStatus={offer.status}*/}
                                        {/*    offerLocation={offer.location}*/}
                                        {/*    newBuildingEmailExtra={newBuildingEmailExtra}*/}
                                        {/*    seller={seller}*/}
                                        {/*    isNewBuilding={isNewBuilding}*/}
                                        {/*    applicationId={ApplicationIdEnum.ClassifiedDesktop}*/}
                                        {/*    realtyType={offer.realtyObject?.__typename}*/}
                                        {/*/>*/}
                                        <OfferCardMortgageButton
                                            scrollToMortgageCalculator={scrollToMortgageCalculator}
                                            isAuth={auth.isAuthenticated}
                                            price={priceValue}
                                            isNewBuilding={isNewBuilding}
                                            regionId={regionId}
                                        />
                                    </div>
                                )}
                                <div className={cn('miniCard-seller', { url: Boolean(developerCardUrl) })}>
                                    <CardAuthorBadge
                                        iconSrc={seller.icon}
                                        name={seller.name}
                                        organizationName={seller.organizationName}
                                        category={seller.sellerType}
                                        url={developerCardUrl}
                                    />
                                </div>
                                {isSamoletRegion && (
                                    <FixedSizeBanner
                                        placementId={bannerRight.placementId}
                                        group={bannerRight.group}
                                    />
                                )}
                            </div>
                            {banners.square && staticPath && (
                                <ImageBanner
                                    view='square'
                                    targetLink={`${banners.square.url}?${AnalyticsFromTags.SpecProjectCardCL}`}
                                    image={banners.square.image.square}
                                    gtm={ClassifiedAnalytics.PromoBannerCardTop}
                                    gtmClickData={getDeveloperBannerGtmData(developerWithPromoName, {
                                        action: 'click',
                                        section: 'banner_right',
                                        pageType: 'card'
                                    })}
                                    gtmShowData={getDeveloperBannerGtmData(developerWithPromoName, {
                                        action: 'view',
                                        section: 'banner_right',
                                        pageType: 'card'
                                    })}
                                />
                            )}
                            {isYandexBanner && (
                                <div style={{ marginTop: '32px' }}>
                                    <YandexBanner variant='offer-sidebar-desk' />
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
        <div className={cn('flex', { colored: true }, 'colored-app-paddings')}>
            <div className={cn('similarBlock')}>
                {/*{price && dealType?.__typename === 'ProfOfferDealRent' && realtyObject?.__typename === 'ProfOfferFlat' && (*/}
                {/*    <MortgageInRentOffers*/}
                {/*        type='offer'*/}
                {/*        offerPrice={price.rubPrice ?? price.value}*/}
                {/*        offerRegion={regionId}*/}
                {/*    />*/}
                {/*)}*/}

                {/*{offer.related?.length ? (<div ref={similarOffersRef}>*/}
                {/*    <SimilarOffers*/}
                {/*        offers={offer.related}*/}
                {/*        isOffer*/}
                {/*        title={offer.related.length === 1 ? 'Похожее объявление' : 'Похожие объявления'}*/}
                {/*    />*/}
                {/*</div>) : null}*/}

                {(! isNewBuilding && offer.similarNb?.length &&
                    dealType?.__typename === 'ProfOfferDealSell' &&
                    realtyObject?.__typename === 'ProfOfferFlat') ? (
                        <SimilarNewBuildingOffersSection
                            similarNbCollection={offer.similarNb}
                            isOffer
                            onSwitchToNb={onSwitchToNb}
                        />
                    ) : null}

                {banners.horizontal && staticPath && (
                    <ImageBanner
                        view='horizontal'
                        targetLink={`${banners.horizontal.url}?${AnalyticsFromTags.SpecProjectCardCL}`}
                        image={banners.horizontal.image.long}
                        gtm={ClassifiedAnalytics.PromoBannerCardBottom}
                        gtmClickData={getDeveloperBannerGtmData(developerWithPromoName, {
                            action: 'click',
                            section: 'banner_left',
                            pageType: 'card'
                        })}
                        gtmShowData={getDeveloperBannerGtmData(developerWithPromoName, {
                            action: 'view',
                            section: 'banner_left',
                            pageType: 'card'
                        })}
                    />
                )}
                {isSamoletRegion && (
                    <FixedHeightBanner
                        placementId={bannerBottom.placementId}
                        group={bannerBottom.group}
                    />
                )}
            </div>
            {isYandexBanner && (<YandexBanner variant='offer-footer-desk' />)}
        </div>
        <RepairModal
            isRepairModal={repairModal}
            closeRepairModal={closeRepairModal}
            area={totalArea.value ?? 30}
        />
        {isPanoramaOpen && coordinates && (
            <Modal
                offTableCSS
                withoutBodyPadding
                size={ModalSize.FULL_M}
                onRequestClose={togglePanorama}
                hugePriorityZIndexEnabled
            >
                <YMapPanoramaDesktop
                    point={coordinates}
                    onClose={togglePanorama}
                    options={{
                        suppressMapOpenBlock: true
                    }}
                />
            </Modal>
        )}
    </>);
});
